module.exports = __webpack_public_path__ + "img/mks-logo-scaled.2c5fd22a.png";